import type { ICreateUserUseCase } from '../use-cases/CreateUserUseCase';
import type { IGetUserUseCase } from '../use-cases/GetUserUseCase';
import type { CreateUserRequest, User } from '../../domain/entities/User';
import type { Result, PaginatedResponse, PaginationParams } from '../../shared/types/common.types';

export interface IUserService {
  createUser(userData: CreateUserRequest): Promise<Result<User>>;
  getUserById(id: string): Promise<Result<User>>;
  getUserByEmail(email: string): Promise<Result<User>>;
  getAllUsers(params: PaginationParams): Promise<Result<PaginatedResponse<User>>>;
}

export class UserService implements IUserService {
  private readonly createUserUseCase: ICreateUserUseCase;
  private readonly getUserUseCase: IGetUserUseCase;

  constructor(
    createUserUseCase: ICreateUserUseCase,
    getUserUseCase: IGetUserUseCase
  ) {
    this.createUserUseCase = createUserUseCase;
    this.getUserUseCase = getUserUseCase;
  }

  async createUser(userData: CreateUserRequest): Promise<Result<User>> {
    return await this.createUserUseCase.execute(userData);
  }

  async getUserById(id: string): Promise<Result<User>> {
    return await this.getUserUseCase.execute(id);
  }

  async getUserByEmail(email: string): Promise<Result<User>> {
    return await this.getUserUseCase.executeByEmail(email);
  }

  async getAllUsers(_params: PaginationParams): Promise<Result<PaginatedResponse<User>>> {
    throw new Error('Method not implemented');
  }
}
